<div class="container">
	<div class="login-body">
		<div id="header-logo">
			<div class="login-section">
				<img *ngIf="pageDetails?.ibpLogoPath" class="login-logo" [src]="pageDetails?.ibpLogoPath" alt="Logo"/>
                <img *ngIf="pageDetails?.existsInstituteLogo" class="institute-logo" [src]="pageDetails?.instituteLogoPath" alt="Institute"/>
            </div>
		</div>
		<form class="js-login-form login-form" (keyup.enter)="doValidateForgotPassword()">

			<div class="login-forgot-password-note pb-3" jhiTranslate="login.password.forgot.field.email">
				To reset your password, enter the email address you use to sign in to BMS. You will receive an email with the link to change your password.
			</div>

			<div class="login-form-control" [ngClass]="{ 'login-validation-error': this.errorFields.includes('email') }">
				<span class="login-icon fa" title="{{ 'login.email.title' | translate}}">&#xf0e0;</span>
				<input class="js-login-forgot-password-input login-input login-flat-control" name="email" placeholder="{{ 'login.email.title' | translate}}" type="text" [(ngModel)]="model.email" />
			</div>

			<div *ngIf="!this.isFormValid" class="js-login-error">
				<span class="fa login-warning-icon">&#xf12a;</span>
				<span class="js-login-error-text">{{this.errorMessage}}</span>
			</div>

			<button class="js-login-submit login-submit login-flat-control login-clickable" formnovalidate="" type="button"
					(click)="doValidateForgotPassword()" [disabled]="isLoading" [ngClass]="{ 'loading': isLoading }">
				<span *ngIf="isLoading" class="throbber throbber-btn"></span>
				<span class="login-submit-label" jhiTranslate="continue">Continue</span>
			</button>
		</form>

		<div id="message">
			<div ng-if="pageDetails != null && pageDetails.footerMessage != ''">
				<div [textContent]="pageDetails.footerMessage" class="login-footer-message">
				</div>
			</div>
		</div>

		<div id="footer">
			<div class="login-footer">
				<img *ngIf="pageDetails?.ibpLogoPath" class="login-footer-logo" [src]="pageDetails?.ibpLogoPath" alt="Logo"/>
				<div class="login-footer-body">
					<span jhiTranslate="about.version.prefix"></span><span [innerText]="version"></span> &bull;
					{{'login.provider.message' | translate}} <a href="https://www.integratedbreeding.net/" jhiTranslate="login.provider.ibp">Integrated Breeding Platform</a>
				</div>
			</div>
			<jhi-languange-selector></jhi-languange-selector>
		</div>
	</div>
</div>
